import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./styles.scss";
import useLang from "hooks/useLang";
import Feature from "./Feature";

const AboutUs = () => {
  useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
  const { lang } = useLang();

  return (
    <section className="section about bg-light" id="about-us">
      <Container>
        <Row className="text-center">
          <Col lg={12}>
          {/* <p>
          ADINATA Consulting Indonesia, sebagai nama terdepan dalam konsultasi
            pajak, menawarkan satu dekade pengalaman spesialis dalam menyediakan
            solusi manajemen pajak yang optimal. Firma kami diakui sebagai
            mercusuar pengetahuan dan inovasi dalam lanskap pajak yang dinamis.
            Selama masa berprofesi sebagai konsultan pajak, kami telah
            mempertajam keahlian kami tidak hanya untuk memenuhi kepatuhan,
            tetapi juga untuk merancang strategi pajak yang selaras dengan
            kebutuhan unik setiap klien. Tim kami yang berpengalaman
            menggabungkan pengetahuan industri yang mendalam dengan teknologi
            canggih untuk menyampaikan layanan yang efisien dan transformatif.
            Sebagai penasihat terpercaya, kami berkomitmen untuk mempertahankan
            standar profesionalisme dan integritas yang tertinggi. Di ADINATA
            Consulting Indonesia, kami memahami bahwa pengelolaan pajak yang
            efektif sangat penting untuk keberlanjutan dan pertumbuhan bisnis.
            Oleh karena itu, kami berusaha untuk membekali klien kami dengan
            alat dan wawasan yang diperlukan untuk menavigasi kompleksitas
            perpajakan, memungkinkan mereka untuk fokus pada apa yang mereka
            lakukan terbaik—mengembangkan bisnis mereka. Untuk kemitraan yang
            melampaui kepatuhan dasar dan berusaha untuk menambahkan nilai nyata
            ke operasi Anda, pilih ADINATA Consulting Indonesia—tempat
            pengalaman dan inovasi bertemu untuk menciptakan solusi pajak yang
            luar biasa.
          </p> */}
          </Col>
        </Row>
      </Container>
      <div className="section features">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} style={{textAlign: "-webkit-center"}}>
              {/* <div className="sec-hd"> */}
                {/* <span className="heading"></span> */}
                <h2 className="sec-title">{lang.about_us.section_1_title}</h2>
                {/* <span className="heading"></span> */}
              {/* </div> */}
                <p style={{width: "50%"}}>
                  {lang.about_us.mission}
                </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={5} md={10} data-aos="fade-right">
              <Feature icon="uil-brightness" title={lang.about_us.vision_1} description={lang.about_us.vision_1_description} />
              <Feature icon="uil-arrow-growth" title={lang.about_us.vision_2} description={lang.about_us.vision_2_description} />
              <Feature icon="uil-suitcase-alt" title={lang.about_us.vision_3} description={lang.about_us.vision_3_description} />
              <Feature icon="uil-cloud-computing" title={lang.about_us.vision_4} description={lang.about_us.vision_4_description} />
            </Col>
            {/* <Col lg={4}>
              <div className="text-center">
                <img src={features} className="img-fluid" data-aos="zoom-in" alt="" />
              </div>
            </Col> */}
            <Col lg={2} />
            <Col lg={5} md={10} data-aos="fade-left">
              <Feature icon="uil-user-arrows" title={lang.about_us.vision_5} description={lang.about_us.vision_5_description} />
              <Feature icon="uil-book-open" title={lang.about_us.vision_6} description={lang.about_us.vision_6_description} />
              <Feature icon="uil-signal" title={lang.about_us.vision_7} description={lang.about_us.vision_7_description} />
              <Feature icon="uil-university" title={lang.about_us.vision_8} description={lang.about_us.vision_8_description} />
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default AboutUs;
